
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicine-interactions",
      function () {
        return require("private-next-pages/medicine-interactions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medicine-interactions"])
      });
    }
  